import { render, staticRenderFns } from "./teaser.vue?vue&type=template&id=3afa3688&scoped=true&"
var script = {}
import style0 from "./teaser.vue?vue&type=style&index=0&lang=css&"
import style1 from "./teaser.vue?vue&type=style&index=1&id=3afa3688&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afa3688",
  null
  
)

export default component.exports